import Client from 'components/Client'
import cookies from 'lib/cookies'
import { logException } from 'lib/errors'
import { getCurrentUser, isLoggedIn } from 'lib/utils/store/currentUser'

import updateAuthUserActivity from 'graphql/app/updateAuthUserActivity.gql'

let lastActivityQueryTriggered = null

const UPDATE_INTERVAL = 10 * 60 * 1000 // Do not allow to call last activity query no more than 1 x every 10 min(s)

const checkInterval = () => {
    return !lastActivityQueryTriggered || (Date.now() - lastActivityQueryTriggered) > UPDATE_INTERVAL
}

/**
 * Log activity of authenticated user
 */
export const logAuthUserActivity = () => {
    if (!checkInterval()) return // check that we don't call too often
    if (!cookies.get('userLoggedIn')) return
    if (!isLoggedIn(getCurrentUser())) return

    lastActivityQueryTriggered = Date.now()
    Client.mutate({ mutation: updateAuthUserActivity }).catch((e) => {
        // Only log error if user was logged in
        if (isLoggedIn(getCurrentUser()) && cookies.get('userLoggedIn')) {
            logException(e)
        }
    })
}
